<template>
  <div>
    <el-table
      :data="aRoomDetailHisOwnerInfo.owners"
      border
      style="width: 100%; margin-top: 10px"
    >
      <el-table-column prop="name" :label="$t('aRoomDetailHisOwner.ownerName')" align="center" />
      <el-table-column prop="link" :label="$t('aRoomDetailHisOwner.ownerPhone')" align="center" />
      <el-table-column prop="oweFee" :label="$t('aRoomDetailHisOwner.oweFee')" align="center">
        <template slot-scope="scope">
          {{ scope.row.oweFee || '0.00' }}
        </template>
      </el-table-column>
      <el-table-column prop="oweFeeCount" :label="$t('aRoomDetailHisOwner.oweFeeCount')" align="center">
        <template slot-scope="scope">
          {{ scope.row.oweFeeCount || 0 }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('aRoomDetailHisOwner.feeHandleType')" align="center">
        <template slot-scope="scope">
          {{ getFeeHandleTypeName(scope.row.feeHandleType) }}
        </template>
      </el-table-column>
      <el-table-column prop="transferOwnerName" :label="$t('aRoomDetailHisOwner.transferOwnerName')" align="center">
        <template slot-scope="scope">
          {{ scope.row.transferOwnerName || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="startTime" :label="$t('aRoomDetailHisOwner.startTime')" align="center" />
      <el-table-column prop="endTime" :label="$t('aRoomDetailHisOwner.endTime')" align="center" />
      <el-table-column prop="createTime" :label="$t('aRoomDetailHisOwner.createTime')" align="center" />
      <el-table-column :label="$t('aRoomDetailHisOwner.changeType')" align="center">
        <template slot-scope="scope">
          {{ getChangeTypeName(scope.row.operate) }}
        </template>
      </el-table-column>
      <el-table-column prop="operatorUserName" :label="$t('aRoomDetailHisOwner.operatorUserName')" align="center">
        <template slot-scope="scope">
          {{ scope.row.operatorUserName || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="remark" :label="$t('aRoomDetailHisOwner.remark')" align="center" />
      <el-table-column :label="$t('aRoomDetailHisOwner.status')" align="center">
        <template slot-scope="scope">
          {{scope.row.statusCd === '0' ? $t('aRoomDetailHisOwner.active') : $t('aRoomDetailHisOwner.inactive')}}
        </template>
      </el-table-column>
    </el-table>

    <el-row class="margin-top">
      <el-col :span="24" class="text-right">
        <el-pagination
          @current-change="handlePageChange"
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          layout="total, prev, pager, next"
          :total="pagination.total"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryAdminRoomHisOwner } from '@/api/aCommunity/aRoomDetailHisOwnerApi'

export default {
  name: 'ARoomDetailHisOwner',
  data() {
    return {
      aRoomDetailHisOwnerInfo: {
        owners: [],
        ownerId: '',
        roomId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(data) {
      if (!data.roomId) return
      this.clearData()
      this.aRoomDetailHisOwnerInfo.roomId = data.roomId
      this.loadOwnerData()
    },
    loadOwnerData() {
      const params = {
        page: this.pagination.currentPage,
        row: this.pagination.pageSize,
        roomId: this.aRoomDetailHisOwnerInfo.roomId
      }

      queryAdminRoomHisOwner(params).then(response => {
        this.aRoomDetailHisOwnerInfo.owners = response.data
        this.pagination.total = response.total
      }).catch(error => {
        console.error('Failed to load owner history:', error)
        this.$message.error(this.$t('aRoomDetailHisOwner.loadError'))
      })
    },
    handlePageChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadOwnerData()
    },
    getChangeTypeName(changeType) {
      const typeNames = {
        CURRENT: 'currentRelation',
        RELATION_DELETE: 'ownerExit',
        RELATION_INVALID: 'relationInvalid',
        HISTORY_MIGRATION: 'historyMigration'
      }
      const typeName = typeNames[changeType] || 'relationInvalid'
      return this.$t(`aRoomDetailHisOwner.${typeName}`)
    },
    getFeeHandleTypeName(handleType) {
      const typeNames = {
        KEEP: 'feeHandleKeep',
        TRANSFER: 'feeHandleTransfer',
        WRITE_OFF: 'feeHandleWriteOff'
      }
      const typeName = typeNames[handleType] || 'feeHandleKeep'
      return this.$t(`aRoomDetailHisOwner.${typeName}`)
    },
    clearData() {
      this.aRoomDetailHisOwnerInfo = {
        owners: [],
        ownerId: '',
        roomId: ''
      }
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}
.text-right {
  text-align: right;
}
</style>
